import {qspost,upload} from '@/plugins/axios'
import {fileUpUrl} from "../config";

/*
 * 绑定微信
 * @constructor jack
 * */

export const bindWx = (code,type = 0) => qspost('Home/User/bindWx', {code,type})

/*
 * 解绑微信
 * @constructor jack
 * */

export const unBindWx = () => qspost('Home/User/unbound', {})

/*
 * 修改手机号
 * @constructor jack
 * */

export const setPhone = (oldphone,newphone,code) => qspost('Home/User/setPhone', {oldphone,newphone,code})

/*
 * 1密码修改
 * @constructor jack
 * */

export const setPass = (oldpass,newpass,repass) => qspost('Home/User/setPass', {oldpass,newpass,repass})

/*
 * 用户详情
 * @constructor jack
 * */

export const userInfo = () => qspost('Home/User/getInfo', {})

/*
 * 获得用户积分列表
 * @constructor jack
 * */

export const userIntegralList = (page, limit, type, user_id, oid) => qspost('Admin/Integral/integralDetail', {page, limit, type, user_id, oid})

/*
 * 检查用户的未读通知条数 - 返回条数，全部已读返回 0
 * @constructor jack
 * */

export const userRemindState = () => qspost('/Home/Index/userRemindState', {})
/*
 * 检查用户的通知未读通知条数 - 返回条数，全部已读返回 0
 * @constructor jack
 * */

export const userNoticeRemindState = () => qspost('/Home/Notice/userNoticeRemindState', {})

/*
 * 基本信息修改
 * @constructor jack
 * */

export const setInfo = (userMoreJson) => qspost('Home/User/setInfo', {userMoreJson})

/*
* 信息管理-自定义表单获取
*
* */
export const getInformation = () => qspost('Home/User/getUserMoreJson', {})

/*
* 信息管理-自定义表单获取
*
* */
export const getRankList = (user_type) => qspost('/Home/User/getRankList', {user_type})

/*
 * 发票信息修改
 * @constructor jack
 * */

export const setInvoice = (invoice_name, invoice_identifier,invoice_tel, invoice_address,email) =>
    qspost('Home/User/setInvoice', {invoice_name, invoice_identifier,invoice_tel, invoice_address,email})

/*
 * 发票申请
 * @constructor jack
 * */

export const applyInvoice = (id) => qspost('Home/User/apply', {id})

/*
 *  缴费信息列表
 * @constructor jack
 * */

export const getPayLog = () => qspost('Home/User/getPayLog', {})

/*
 *  首页会员各项说明
 * @constructor jack
 * */

export const getArticleList = () => qspost('Home/Article/getList', {})
/*
 *  首页会员各项说明
 * @constructor jack
 * */

export const getArticle = (id) => qspost('Home/Article/getInfo', {id})


/*
 *  首页通知公告列表
 * @constructor jack
 * */

export const getNotice = () => qspost('Home/Index/getNotice', {})

/*
 *  通知公告列表
 * @constructor jack
 * */

export const getNoticeList = (page,limit) => qspost('Home/Notice/getLIst', {page,limit})

/*
 *  首页通知公告详情
 * @constructor jack
 * */

export const getNoticeDetail = (id) => qspost('Home/Notice/detail', {id})

/*
 *  2反馈提交
 * @constructor jack
 * */

export const feedbackNotice = (id,content) => qspost('Home/Notice/feedback', {id,content})


/*
 *  首页活动会议列表
 * @constructor jack
 * */

export const getMeeting = () => qspost('Home/Index/getMeeting', {})

/*
 *  首页活动会议列表
 * @constructor jack
 * */

export const getMeetings = (status,type,page,limit) => qspost('Home/Meeting/getList', {status,type,page,limit})

/*
 *  首页活动会议列表
 * @constructor xhx
 * */

export const getMeetingDetail = (id) => qspost('https://yhb.emof.cn/index.php/Index/Show/Index', {id})

/*
 *  首页动态
 * @constructor jack
 * */

export const getActives = (keyword,page,limit) => qspost('home/Noticeactive/query', {keyword,page,limit})

/*
 *  首页动态详情
 * @constructor jack
 * */

export const getActiveDetail = (id) => qspost('home/Noticeactive/detail', {id})


/*
 *  服务中心列表
 * @constructor jack
 * */

export const getServerList = () => qspost('Home/Server/getList', {})

/*
 *  服务中心申请记录
 * @constructor jack
 * */

export const getServerRecord = () => qspost('Home/Server/myApplyServerList', {})

/*
 *  服务中心列表详情
 * @constructor jack
 * */

export const getServerDetail = (id) => qspost('Home/Server/detail', {id})

/*
 *  活服务中心列表详情服务申请
 * @constructor jack
 * */

export const applyServer = (id,content) => qspost('Home/Server/addApply', {id,content})


/*
 *  会员说明列表
 * @constructor xhx
 * */
export const getMemberexplainList = () => qspost('Home/Article/getList', {})

/*
*  会员说明详情
* @constructor xhx
* */
export const getMemberexplainDetail = (id) => qspost('/Home/Article/getInfo', {id})


/*
 *  机构介绍
 * @constructor jack
 * */

export const getOrganizInfo = (keyword,page,limit) => qspost('Home/User/getParentInfo', {keyword,page,limit})

/*
 *  审核日志
 * @constructor jack
 * */

export const getApplyLog = () => qspost('Home/Index/userApplyLog', {})

/*
 *  意见反馈列表
 * @constructor jack
 * */

export const getMessageList = () => qspost('Home/Message/getMyList', {})

/*
 *  提交意见
 * @constructor jack
 * */

export const addMessage = (content) => qspost('Home/Message/add', {content})


/*
 *  支付页信息
 * @constructor jack
 * */

export const getOrderInfo = () => qspost('home/order/index', {})

/*
 *  支付页信息
 * @constructor jack
 * */

export const wxPay = (duration,pay_type,is_invoice,invoice_name,invoice_identifier,email) => qspost('home/order/create', {duration,pay_type,is_invoice,invoice_name,invoice_identifier,email})

/*
 *  支付页信息
 * @constructor jack
 * */

export const h5WechatXuFei = (code,duration,pay_type,is_invoice,invoice_name,invoice_identifier) => qspost('/home/wechat/h5WechatXuFei', {code,duration,pay_type,is_invoice,invoice_name,invoice_identifier})

/*
 *  检查支付状态
 * @constructor jack
 * */

export const checkPayState = (order_number) => qspost('home/wechat/checkPayState', {order_number})


/*
 *  对公信息提交
 * @constructor jack
 * */

export const transferPay = (order_number,pay_type_2_image) => qspost('home/order/orderPayType2', {order_number,pay_type_2_image})


/*
 *  用户证书
 * @constructor jack
 * */

export const getZhengShu = () => qspost('home/user/getZhengShu', {})



/*
 *  用户证书
 * @constructor jack
 * */

export const getCommonProblem = (searchKey) => qspost('/home/index/commonProblem', {searchKey})


/*
 *  用户证书
 * @constructor jack
 * */

export const getCommonProblemDetail = (id) => qspost('/home/index/commonProblemData', {id})

/*
 *  获取个人所有机构下的账号
 * @constructor jack
 * */

export const getOrgListByUserPhone = (userId,userPhone) => qspost('/home/index/getOrgListByUserPhone', {userId,userPhone})


/*
 *  会员切换登录的机构
 * @constructor jack
 * */

export const userLoginByMidAndUserId = (userId) => qspost('/home/index/userLoginByMidAndUserId', {userId})


/*
 * 获得对公转账的信息
 * */

export const getDuiGongData = (userId) => qspost('home/User/getDuiGongData', {userId})


/*
 * 积分详情
 * */

export const getIntegralDetail = (oid,user_id,type,page,limit) => qspost('Admin/Integral/integralDetail', {oid,user_id,type,page,limit})


/*
 * 使用说明
 * type  // 1会员端、2管理端、3分会、4子管理
btype // 1pc端 2手机端
 * */

export const getHelpList = (type,btype) => qspost('home/help/getInfo', {type,btype})


/*
 * 上传图片
 * */
export const uploadFile = (params) => upload(fileUpUrl, params)

